module.exports = __webpack_public_path__ + "img/tramites-cel.ba5a3409.png";